/**
 * @file BrandMark.tsx
 * @description AI Systems logo + localized portal wordmark. Used in the
 *   public header and authenticated app header so the supplied company
 *   identity stays consistent across the customer journey.
 * @module Components
 * @security The image is a bundled same-origin asset and no user input is
 *   interpolated into its source URL.
 */

import type { JSX } from 'react';

interface BrandMarkProps {
  label: string;
  /** Renders the wordmark for a dark background (app chrome). */
  onDark?: boolean;
}

export function BrandMark({ label, onDark }: BrandMarkProps): JSX.Element {
  return (
    <div className="flex items-center gap-3">
      <img
        src="/ai-systems-logo.png"
        alt=""
        aria-hidden="true"
        className="h-14 w-14 shrink-0 rounded-xl bg-white object-contain shadow-card"
      />
      <span className={`font-semibold ${onDark === true ? 'text-white' : 'text-slate-900'}`}>
        {label}
      </span>
    </div>
  );
}
